import { instance } from "apis/interceptor";
import axios from "axios";
import { TUser } from "apis/user";

export const registerUserWithMile = async (
  email: string,
  name: string,
  password: string,
  acceptTerm: boolean,
  acceptPrivacy: boolean,
  emailVerificationToken?: string
) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/sign-up/mile`,
      {
        email: email,
        name: name,
        password: password,
        acceptTerm: acceptTerm,
        acceptPrivacy: acceptPrivacy,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${emailVerificationToken}`,
        },
      }
    );

    return { success: res.data.result, message: "" };
  } catch (error: any) {
    const statusCode = error.response.status;
    if (statusCode === 400) {
      return { success: false };
    } else if (statusCode === 409) {
      return { success: false, statusCode: 409 };
    }
  }
};

export const registerUserWithGoogle = async (
  email: string,
  name: string,
  acceptTerm: boolean,
  acceptPrivacy: boolean,
  googleAccessToken: string
): Promise<{ success: boolean; accessToken?: string; user?: TUser }> => {
  try {
    const res = await instance.post("/auth/sign-up/google", {
      email: email,
      name: name,
      acceptTerm: acceptTerm,
      acceptPrivacy: acceptPrivacy,
      googleAccessToken: googleAccessToken,
      redirectUri: `${process.env.REACT_APP_WEB_URL}/google/redirect/sign-up`,
    });
    const { accessToken, user } = res.data;
    return { success: true, accessToken: accessToken, user: user };
  } catch (error: any) {
    return { success: false };
  }
};

export const checkExistingUserByEmail = async (
  email: string
): Promise<{ success: boolean; loginProvider?: string; isExisted?: boolean }> => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/check-existing-user/by-email`, {
      email: email,
    });
    return { success: true, loginProvider: res.data.loginProvider, isExisted: res.data.isExisted };
  } catch (error: any) {
    return { success: false };
  }
};
